<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div class="item van-hairline--bottom">
        <div class="flex_center">
          <div class="info">{{ $t('lang.zh') }}</div>
        </div>
        <div>✓</div>
      </div>
    </div>
  </div>
</template>
  
  <script>


export default {
  name: "Language",
  data() {
    return {
      lang: "zh"
    };
  },
  created() {
    localStorage.setItem("lang", "zh");
    this.$i18n.locale = "zh";
    this.replaceLang();
  },
  methods: {
    back(){
      return window.history.back();
    },
    replaceLang() {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: {
          lang: "zh",
        },
      });
    },
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.nav-bar{
  background: #1f1c1f;
  height: 100px;

}
.container .items {
  background: linear-gradient(120deg, #212121, #313131);
  font-size: 30px;
  color: #f3c7a2;
  padding:  25px;
}
.container .items .item {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
  padding: 10px 0;
}
.flex_center {
  display: flex;
  align-items: center;
}
</style>
